import CompteDetailView from "@/pages/super-admin/components/CompteDetailView";

export default function SuperAdminUtilisateurDetailPage() {
  return <CompteDetailView type="utilisateur" />;
}